module.exports = __webpack_public_path__ + "68b52d44b52c0473798862d46ea08efd.png";